import { render, staticRenderFns } from "./InformationSetting.vue?vue&type=template&id=289b21d5&"
import script from "./InformationSetting.vue?vue&type=script&lang=js&"
export * from "./InformationSetting.vue?vue&type=script&lang=js&"
import style0 from "./InformationSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports